<style lang="scss" scoped>
@import "core";

.my-lead {
  margin-bottom: 15px;
  color: $color-strong;
}

.my-ie-message {
  margin-top: 10px;

  &__guide {
    font-size: 90%;
  }
}

.my-step-list {
  & > li {
    margin-top: .5em;
  }
}
</style>



<template>
  <error-dialog-base ref="base">
    <div slot="header">ブラウザの設定により<wbr>データの保存が<wbr>無効化されています</div>

    <div>
      <p>プライベートブラウズ状態でページが表示されている、もしくはブラウザのストレージ設定が無効化されているためデータの保存ができません。<br>
      プライベートブラウズ状態を解除して頂くか、お使いのブラウザごとに以下の手順をお試しください。</p>
      <my-howtocookie />
    </div>
  </error-dialog-base>
</template>



<script>
import DialogMixin from './dialogMixin';
import HowToCookie from './partials/HowToCookie';



export default {
  mixins: [DialogMixin],

  components: {
    'my-howtocookie': HowToCookie,
  },

  props: {
    privateBrowse: Boolean,
    storageIsDisabled: Boolean,
  },
}
</script>



// WEBPACK FOOTER //
// DialogStorageDisabledError.vue?480b7c64